import { Bell, GenAI, Home, Setting, Shield } from "../../../assets/svg-icons";
import { processNodeAndPermissions } from "../../../helper/com-helper";

const CORTEX_OBJECT = {
  name: "Cortex",
  route: "/agentic-ai/dashboard",
  permissions: ["GENAI_VIEW"],
  // child: {
  //   "Home":{
  //     name: "Home",
  //     route: "/agentic-ai/agent-cortex-home",
  //     permissions: ["GENAI_VIEW"],
  //     icon: Home,
  //     shortName: "Home",
  //   },
  //   "Alerts":{
  //     name: "Alerts",
  //     route: "/agentic-ai/alerts",
  //     permissions: ["GENAI_VIEW"],
  //     icon: Bell,
  //     shortName: "Alerts",
  //   },
  //   "Settings":{
  //     name: "Settings",
  //     route: "/agentic-ai/settings",
  //     permissions: ["GENAI_VIEW"],
  //     icon: Setting,
  //     shortName: "Settings",
  //   },
  //   "Admin":{
  //     name: "Admin",
  //     route: "/agentic-ai/admin",
  //     permissions: ["GENAI_VIEW"],
  //     icon: Shield,
  //     shortName: "Admin",
  //   },
  //   "Agent": {
  //     name: "Agent",
  //     route: null,
  //     permissions: ["GENAI_VIEW"],
  //     icon: GenAI,
  //     shortName: "Agents",
  //     child: {
  //       "Agent List": {
  //         name: "Agent List",
  //         route: "/agentic-ai/agent-table",
  //         permissions: ["GENAI_VIEW"],
  //       },
  //       "Create New": {
  //         name: "Create New",
  //         route: "/agentic-ai/createnewagent",
  //         permissions: ["GENAI_VIEW"],
  //       },
  //       "Pilot": {
  //         name: "Pilot",
  //         route: "/agentic-ai/pilot",
  //         permissions: ["GENAI_VIEW"],
  //       },
  //       "Playground": {
  //         name: "Playground",
  //         route: "/agentic-ai/playground",
  //         permissions: ["GENAI_VIEW"],
  //       },

  //     },
  //   },
  // },
};

processNodeAndPermissions(CORTEX_OBJECT);
export const CORTEX = CORTEX_OBJECT;